<script>
export default 
{
    name: 'notifications',

    methods:
    {
        send()
        {
            this.$api('post', '/v1/admin/notifications', this.model).then(res => {
                this.model.title = null
                this.model.message = null
            })
        },
    },

    data()
    {
        return {
            model: {
                title: null,
                message: null,
            }
        }
    }
}
</script>

<template>
<div class="container-fluid">
    <div class="panel panel-primary">
        <div class="panel-heading">
            <div class="row">
                <div class="col-sm-12">
                    <h4>{{ $t('MENU.NOTIFICATIONS') }}</h4>
                </div>
            </div>
        </div>
        <div class="panel-body">
            <form @submit.prevent.stop="send">
                <div class="form-group row">
                    <label class="col-md-4 control-label">
                        {{ $t('GENERAL.TITLE') }}
                    </label>
                    <div class="col-md-6">
                        <input class="form-control" type="text" v-model="model.title" required>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 control-label">
                        {{ $t('GENERAL.TEXT') }}
                    </label>
                    <div class="col-md-6">
                        <textarea class="form-control" v-model="model.message" rows="16" required>
                        </textarea>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-12 text-right">
                        <button class="btn btn-success">{{ $t('GENERAL.SEND') }}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>




// WEBPACK FOOTER //
// src/pages/Notifications.vue